import { Object } from "core-js";

if (!Node.prototype.contains) {
    Object.defineProperty(Node.prototype, 'contains', {
        value: function(node) {
            do {
                if (this === node) {
                    return true;
                }
            } while (node = node && node.parentNode);
            return false;
        }
    });
}



// WEBPACK FOOTER //
// ./resources/components/polyfills/contains/index.js